import React, { Component } from 'react';
import HeaderForm from './HeaderForm';
import BaseLayout from './BaseLayout';
import { LoadPanel } from 'devextreme-react/load-panel';
const initialState = {
	showLoadingPanel: false,
};
export default class BaseForm extends Component {
	state = { ...initialState };
	constructor(props) {
		super(props);
		this.loadingPanel = React.createRef();
	}
	showLoadingPanel(show) {
		this.setState({ showLoadingPanel: show });
	}
	render(props) {
		return (
			<React.Fragment>
				<LoadPanel
					shadingColor={'rgba(0,0,0,0.4)'}
					position={{ of: '#root' }}
					visible={this.state.showLoadingPanel}
					showIndicator={true}
					shading={true}
					showPane={false}
				/>
				<BaseLayout>
					<HeaderForm {...this.props} />
					<section className="content">{this.props.children}</section>
				</BaseLayout>
			</React.Fragment>
		);
	}
}
